import React from "react";
import ComingSoon from "../common/ComingSoon";

function MentorshipPrograms({ theme }) {
  return <ComingSoon theme={theme} />;
}

export default MentorshipPrograms;
